module.exports = __webpack_public_path__ + "static/media/amrc.b66f5142.png";